// extracted by mini-css-extract-plugin
export default {"obitsListWrapper":"ObitsListing_obitsListWrapper__9uoik","resultsTableWrapper":"ObitsListing_resultsTableWrapper__F-g18"};